import { defineStore } from "pinia";
import { ref } from "vue";

type DialogType = "confirm" | "prompt" | "alert";

interface DialogRequest {
  type: DialogType;
  message: string;
  defaultValue?: string | undefined;
  resolve: (value: unknown) => void;
}

export const useDialogStore = defineStore("dialog", () => {
  const currentRequest = ref<DialogRequest | null>(null);

  const confirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      currentRequest.value = {
        type: "confirm",
        message,
        resolve: resolve as (value: unknown) => void,
      };
    });
  };

  const prompt = (
    message: string,
    defaultValue?: string
  ): Promise<string | null> => {
    return new Promise((resolve) => {
      currentRequest.value = {
        type: "prompt",
        message,
        defaultValue,
        resolve: resolve as (value: unknown) => void,
      };
    });
  };

  const alert = (message: string): Promise<void> => {
    return new Promise((resolve) => {
      currentRequest.value = {
        type: "alert",
        message,
        resolve: resolve as (value: unknown) => void,
      };
    });
  };

  const closeDialog = (value: unknown) => {
    if (currentRequest.value) {
      currentRequest.value.resolve(value);
      currentRequest.value = null;
    }
  };

  return {
    currentRequest,
    confirm,
    prompt,
    alert,
    closeDialog,
  };
});
